import { forwardRef } from 'react';
import Textarea from '../../textarea/Textarea';
import useSectionHighlightRef from '../../../hooks/useSectionHighlightRef';

const ThingsToCarry = forwardRef(({ tempData, setTempData }, ref) => {
    const { sectionRef, highlightField } = useSectionHighlightRef(ref);
    return (
        <div ref={sectionRef}>
            <h2 className='orgPackUpH2'>Things To Carry</h2>
            <div className='orgPackUpSecDiv'>
                <div>
                    <p className='tagsNoteP'>
                        Note: Type each point in new(press enter) line (each new point should come in next line). Don't
                        number the points as it will be numbered automatically on the user end
                    </p>
                </div>
                <Textarea
                    label='Things To Carry'
                    name='carry'
                    value={tempData.carry}
                    placeholder='What are the Things need to carry in this package'
                    setFormData={setTempData}
                    directInDiv='orgPackUpInputDiv'
                    labelCss='orgPackUpLabel'
                    inputCss='orgPackUpInput'
                    min={20}
                    limit={800}
                    error={highlightField === 'carry'}
                />
            </div>
        </div>
    );
});

export default ThingsToCarry;
